import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const PaymentsService = {

    getSettings: (account_id) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.PAYMENTS}get-settings`, { params: { account_id } });
    },

    saveSettings: (data: {
        account_id,
        active_orders_per_cliente,
        expire_after_of,
        template,
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.PAYMENTS}settings`, data);
    },
    
    toggleStatus: (account_id) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.PAYMENTS}toggle-status`, { account_id });
    },
    
    setEnvironment: (data: {
        account_id, 
        is_sandbox, 
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.PAYMENTS}set-env`, data );
    },
    
    saveOpenPaySettings: (data: {
        account_id, 
        is_default_payment, 
        id, 
        private_key, 
        public_key, 
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.PAYMENTS}openpay`, data );
    },
    
    savePayPalSettings: (data: {
        account_id, 
        is_default_payment, 
        client_id, 
        secret, 
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.PAYMENTS}paypal`, data );
    },
    
    saveConektaSettings: (data: {
        account_id, 
        is_default_payment, 
        private_key, 
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.PAYMENTS}conekta`, data );
    },
    
    setDefaultPayment: (data: {
        account_id,
        payment_name,
        status,
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.BOT_V3}handle-default-payment`, data );
    },
   
}